import { Component, inject } from '@angular/core';
import { BaseTemplate } from '../../templates/base-template/base-template';
import { StepperItem } from '../../components/stepper-item/stepper-item';
import { TranslateModule } from '@ngx-translate/core';
import { ApiService } from '../../services/api-service';
import { WebSocketService } from '../../services/websocket-service';

@Component({
  selector: 'app-connected-page',
  imports: [BaseTemplate, StepperItem, TranslateModule],
  templateUrl: './connected-page.html',
  styleUrl: './connected-page.scss',
})
export class ConnectedPage {
  apiService: ApiService = inject(ApiService);
  webSocketService: WebSocketService = inject(WebSocketService);

  ngOnInit(): void {
    this.webSocketService.clear();
    this.apiService.clear();
  }
}
